import { render, staticRenderFns } from "./QuestionAction.vue?vue&type=template&id=3465f96e&scoped=true"
import script from "./QuestionAction.vue?vue&type=script&lang=js"
export * from "./QuestionAction.vue?vue&type=script&lang=js"
import style0 from "./QuestionAction.vue?vue&type=style&index=0&id=3465f96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465f96e",
  null
  
)

export default component.exports